import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import authService from "../../services/authService";
import {
  Container,
  Form,
  Heading,
  Input,
  ButtonBase,
  Error,
  FlexContainer,
  HeroSection,
  HeroContent,
  HeroImage,
  FeatureCard,
} from "../../styled/common";
import { FaClipboardList, FaChartBar, FaUserCog } from "react-icons/fa";
import inventoryImage from "../../assets/inventory-management.jpg";
import companyLogo from "../../assets/company-logo.jpg";

const SignIn = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [userId, setUserId] = useState(null);
  const [otpStage, setOtpStage] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleInitialLogin = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const { token, user, userId } = await authService.signIn({ email, password });

      if (userId) {
        setUserId(userId);
        setOtpStage(true);
      } else if (token && user) {
        onLogin(user);
        navigate("/profile");
      }
    } catch (err) {
      const message = err.response?.data?.message || err.message || "An unexpected error occurred";
      setError(message);
    }
  };

  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      const { user } = await authService.verifyOtp({ userId, otp });
      onLogin(user);
      navigate("/profile");
    } catch (err) {
      const message = err.response?.data?.message || err.message || "Invalid or expired OTP.";
      setError(message);
    }
  };

  const renderForm = () => (
    <Container>
      <Form onSubmit={otpStage ? handleOtpSubmit : handleInitialLogin}>
        <Heading style={{ fontSize: "20px", marginBottom: "16px" }}>
          {otpStage ? "Verify OTP" : "Sign In"}
        </Heading>

        {!otpStage ? (
          <>
            <Input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <Input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </>
        ) : (
          <Input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
          />
        )}

        {error && <Error>{error}</Error>}
        <ButtonBase variant="primary" type="submit" style={{ width: "100%", padding: "10px" }}>
          {otpStage ? "Verify OTP" : "Sign In"}
        </ButtonBase>
      </Form>
    </Container>
  );

  return (
    <HeroSection style={{ gap: "30px" }}>
      {/* ✅ Shared: Logo + Heading */}
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", width: "100%" }}>
        <img src={companyLogo} alt="Company Logo" style={{ width: "240px", marginBottom: "12px" }} />
        <Heading style={{ fontSize: "30px", textAlign: "center", marginBottom: "20px", color: "#333" }}>
          Smarter Inventory Management (SIM)
        </Heading>
      </div>

      {/* ✅ Mobile-only Form */}
      <div className="hide-on-desktop auth-card">
        {renderForm()}
      </div>

      {/* ✅ Desktop-only Layout (Features + Image + Form) */}
      <div className="hide-on-mobile" style={{ display: "flex", flexDirection: "row", gap: "40px", alignItems: "flex-start" }}>
        <HeroContent>
          <FlexContainer justify="space-around" align="center" style={{ gap: "30px" }}>
            <FeatureCard>
              <FaClipboardList size={50} color="#3498db" style={{ marginBottom: "16px" }} />
              <h3>Real-Time Tracking</h3>
              <p>Gain full visibility into stock across multiple locations with real-time updates.</p>
            </FeatureCard>
            <FeatureCard>
              <FaChartBar size={50} color="#2ecc71" style={{ marginBottom: "16px" }} />
              <h3>Automated Reporting</h3>
              <p>Stay ahead with automated reports that provide actionable insights.</p>
            </FeatureCard>
            <FeatureCard>
              <FaUserCog size={50} color="#e74c3c" style={{ marginBottom: "16px" }} />
              <h3>User-Friendly Dashboard</h3>
              <p>Access inventory data in an intuitive dashboard.</p>
            </FeatureCard>
          </FlexContainer>
        </HeroContent>

        <HeroImage>
          <img src={inventoryImage} alt="Inventory Management" />
        </HeroImage>

        <div className="auth-card">
          {renderForm()}
        </div>
      </div>
    </HeroSection>
  );
};

export default SignIn;
